import React from 'react'
import FeatureSplashContent, {VariantRenderContent} from './FeatureSplashContent'
import {Product} from '../../services/cellcast.v2.types'

type FeatureSplashPageProps = {
  title?: string
  description?: React.ReactNode
  product?: Product
  onActivate?: () => void
  ctaLabel?: string
  descText?: string
  showEmbedVideo?: boolean
  embedVideoUrl?: string
}

const FeatureSplashPage: React.FC<FeatureSplashPageProps> = ({
  title,
  description,
  product,
  onActivate,
  ctaLabel,
  descText = 'Feature Overview',
  showEmbedVideo = false,
  embedVideoUrl = '',
}) => {
  return (
    <div className='card'>
      <div className='card-header border-0 pt-7 px-14'>
        <div
          className='card-title align-items-start flex-column'
          style={{
            marginTop: '10px',
            marginBottom: '-40px',
            marginLeft: '20px',
          }}
        >
          <div className='card-label fw-bold'>
            <span
              style={{
                lineHeight: '120%',
                letterSpacing: '0%',
                fontSize: '2rem',
                fontWeight: '700',
              }}
            >
              {title}
            </span>
          </div>
          <span className='text-muted fw-bold fs-4'>{descText}</span>
        </div>
      </div>

      <div className='card-body py-6 px-10'>
        <FeatureSplashContent
          title={title}
          description={description}
          product={product}
          onActivate={onActivate}
          variant={VariantRenderContent.PAGE}
          ctaLabel={ctaLabel}
          showEmbedVideo={showEmbedVideo}
          embedVideoUrl={embedVideoUrl}
        />
      </div>
    </div>
  )
}

export default FeatureSplashPage
